export default __webpack_public_path__ + "static/media/v3.0.39211852.svg";